/**
 * ProviderBadge — Live / Mock / Down badge.
 * Renders a coloured pill the moment a provider's `mode` and `health.ok`
 * are known. Used on every integration-aware page so swapping mock→live
 * requires ZERO UI changes — the badge auto-updates from the backend.
 */
import React from "react";
import { ShieldCheck, ShieldAlert, ShieldOff } from "lucide-react";

const COLORS = {
  live:    { fg: "#10b981", bg: "rgba(16,185,129,0.12)", border: "#10b98144", icon: ShieldCheck, text: "LIVE" },
  mock:    { fg: "#f59e0b", bg: "rgba(245,158,11,0.12)", border: "#f59e0b44", icon: ShieldAlert, text: "MOCK" },
  down:    { fg: "#ef4444", bg: "rgba(239,68,68,0.12)", border: "#ef444444", icon: ShieldOff,  text: "DOWN" },
  unknown: { fg: "#64748b", bg: "rgba(100,116,139,0.12)", border: "#64748b44", icon: ShieldAlert, text: "—"   },
};

export function ProviderBadge({ mode, ok, label, slug, size = "md" }) {
  let kind = "unknown";
  if (ok === false) kind = "down";
  else if (mode === "live") kind = "live";
  else if (mode === "mock") kind = "mock";
  const C = COLORS[kind];
  const Icon = C.icon;
  const dim = size === "sm" ? { p: "2px 8px", fs: 10, ic: 10 } : { p: "4px 10px", fs: 11, ic: 12 };
  return (
    <span
      data-testid={`provider-badge-${slug || "x"}`}
      data-mode={kind}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        padding: dim.p, borderRadius: 999, background: C.bg,
        border: `1px solid ${C.border}`, color: C.fg,
        fontSize: dim.fs, fontWeight: 700, letterSpacing: 0.6,
        textTransform: "uppercase",
      }}
    >
      <Icon size={dim.ic} />
      {label || C.text}
    </span>
  );
}

export default ProviderBadge;
